import { defineStore } from 'pinia'

export const useDragAndDrop = defineStore('drag-and-drop', {
    state: () => ({ 
        draggedData: Object,
        draggedElem: Object,
        dragging: false
    }),

    getters: {
        DraggedData: (state) => state.draggedData,
        Dragging: (state) => state.dragging
    },

    actions: {
        // Caso os eventos já existam, vamos substituir ao invés de retornar da função, assim mantemos os eventos completamente reutilizáveis 
        // Assim se houver mudança na fn, vai ser refletida, também facilita a manutenção futura
        setDragFunctionElem(fn, element) {
            if (element._dragstartHandler)
                element.removeEventListener('dragstart', element._dragstartHandler)

            if (element._dragendHandler)
                element.removeEventListener('dragend', element._dragendHandler)

            const dragstartHandler = (event) => {
                event.dataTransfer.setData('text/plain', 'item')

                this.setDragging(true)
                fn()
            }

            const dragendHandler = () => {
                this.setDragging(false)
            }

            element._dragstartHandler = dragstartHandler
            element._dragendHandler = dragendHandler
            
            element.addEventListener('dragstart', dragstartHandler)
            element.addEventListener('dragend', dragendHandler)
        },

        setDropFunction(fn, element) {
            if (element._dragenterHandler)
                element.removeEventListener('dragenter', element._dragenterHandler)

            if (element._dragoverHandler)
                element.removeEventListener('dragover', element._dragoverHandler)

            if (element._dropHandler)
                element.removeEventListener('drop', element._dropHandler)

            const defaultHandler = (event) => {
                event.preventDefault()
                event.stopPropagation()
            }

            const dropHandler = (event) => {
                event.preventDefault()
                event.stopPropagation()
                fn()
            }

            element._dragenterHandler = defaultHandler
            element._dragoverHandler = defaultHandler
            element._dropHandler = dropHandler
            
            element.addEventListener('dragenter', defaultHandler)
            element.addEventListener('dragover', defaultHandler)            
            element.addEventListener('drop', dropHandler)
        },

        setDraggedElem(elem) {
            this.draggedElem = elem
        },

        setDraggedData(data) {
            this.draggedData = data
        },

        setDragging(bool) {
            this.dragging = bool
        },
    }
})
